
export const MAX_TERM_LENGTH = 4;

export const DEFAULT_COLOR = '#FF0000';

export const MIN_PASSWORD_LENGTH = 8;
